import { registerApi as api } from '../../api';
import { globalApi as apiglobal } from '../../api';

// export const CreateGenerateForm = async (formInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const response = await api.post('/selected_form_generation', formInput, {
//       responseType: 'blob',
//       headers: {
//         'Authorization': `Bearer ${token}`
//       }
//     });

//     const url = window.URL.createObjectURL(new Blob([response.data]));
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', `${formInput.client_name}_${formInput.unit_id}_${formInput.form_type}_${formInput.date}.xlsx`);
//     document.body.appendChild(link)
//       ;
//     link.click();

//     link.parentNode.removeChild(link)
//       ;
//     return {
//       data: response.data,
//       status: response.status,
//     };
//   } catch (error) {
//     if (error.response && error.response.data) {
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = function () {
//           try {
//             const errorMsg = JSON.parse(reader.result).error;
//             console.log(errorMsg);
//             resolve({
//               data: null,
//               error: errorMsg
//             });
//           } catch (e) {
//             const errorMsg = 'Something went wrong';
//             resolve({
//               data: null,
//               error: errorMsg
//             });
//           }
//         };
//         reader.readAsText(error.response.data);
//       });
//     } else {
//       return {
//         data: null,
//         error: error.message
//       };
//     }
//   }
// };

export const CreateGenerateForm = async (formInput, options = {}) => {
  try {
    const token = sessionStorage.getItem('token');
    const { autoDownload = true } = options;
    const nForms = Array.isArray(formInput.form_types) ? formInput.form_types.length : 1;
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
      body: JSON.stringify({
        sessionId: '01c993',
        hypothesisId: 'H3',
        location: 'generateForm.api.jsx:CreateGenerateForm:before_post',
        message: 'selected_form_generation request',
        data: { nForms, format: formInput.format },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion

    const response = await api.post('/selected_form_generation', formInput, {
      responseType: 'blob',
      timeout: 30 * 60 * 1000,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // ✅ Determine extension based on requested format
    const format = formInput.format || 'excel';
    const extMap = {
      excel : { ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      pdf   : { ext: 'pdf',  mime: 'application/pdf' },
      both  : { ext: 'zip',  mime: 'application/zip' },
    };
    const { ext } = extMap[format] || extMap['excel'];

    // ✅ Build filename dynamically (prefer backend filename when provided)
    const disposition = response.headers?.['content-disposition'];
    let headerFilename = null;
    if (disposition && disposition.includes('filename=')) {
      headerFilename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
    }
    const fallbackName = `${formInput.client_name}_${formInput.unit_id}_${formInput.form_type || 'forms'}_${formInput.date}.${ext}`;
    const fileName = headerFilename || fallbackName;

    if (autoDownload) {
      // ✅ Trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    }

    return {
      data: response.data,
      status: response.status,
      fileName,
      failuresSummary: response.headers?.['x-form-generation-failures'] || null,
    };

  } catch (error) {
    if (error.response && error.response.data) {
      // Blob error response — parse JSON error message from blob
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const payload = JSON.parse(reader.result);
            const errorMsg = payload?.error || 'Something went wrong';
            resolve({ data: null, error: errorMsg, errorPayload: payload });
          } catch (e) {
            resolve({ data: null, error: 'Something went wrong' });
          }
        };
        reader.readAsText(error.response.data);
      });
    } else {
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
        body: JSON.stringify({
          sessionId: '01c993',
          hypothesisId: 'H3',
          location: 'generateForm.api.jsx:CreateGenerateForm:catch_no_response',
          message: error?.message || 'request failed',
          data: {
            code: error?.code,
            status: error?.response?.status,
            nForms: Array.isArray(formInput.form_types) ? formInput.form_types.length : 1,
          },
          timestamp: Date.now(),
        }),
      }).catch(() => {});
      // #endregion
      return { data: null, error: error.message };
    }
  }
};
export const uploadGeneratedForm = async (fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_generated_form', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchGeneratedForm = async () => {
    try {
        const user = sessionStorage.getItem('user');
        const company_code = user ? JSON.parse(user).company_code : null;
        const token = sessionStorage.getItem('token');
        const selectedClientID = sessionStorage.getItem('selectedClient');
        const response = await api.get(`/get_generated_form/${company_code}`, {
           headers: {
                'Authorization': `Bearer ${token}`,
            },
            params: {
              'selectedClientID': selectedClientID // Pass selectedClientID as a query parameter
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

// uploadGeneratedForms,fetchAllGeneratedForms,fetchGeneratedForm,updateGeneratedForm,deleteGeneratedForm

export const fetchAllGeneratedForms = async () => {
    try {
      const user = sessionStorage.getItem('user');
        const company_code = user ? JSON.parse(user).company_code : null;
        const response = await api.get(`/get_generated_form/${company_code}`, {
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateGeneratedForm = async (id, formData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_generated_form/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const deleteGeneratedForm = async (id) => {
  try {
      const token = sessionStorage.getItem('token');
      const response = await api.delete(`/delete_generated_form/${id}`, {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      })
      return response.data;
  } catch (error) {
      throw error.response ? error.response.data.error : error.message
  }
}
export const get_client_base_units_form = async (clinet_id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await apiglobal.get(`/get_client_base_units/${clinet_id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}




export const generated_forms_download_file = async (id, downloadName) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/generated_forms_download/${id}`, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    const disposition = response.headers['content-disposition'] || '';
    let filename = 'download.xlsx';
    const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
    if (utfMatch) {
      try {
        filename = decodeURIComponent(utfMatch[1].trim());
      } catch {
        filename = utfMatch[1].trim();
      }
    } else if (plainMatch) {
      filename = plainMatch[1].replace(/['"]/g, '').trim();
    }
    if (downloadName) {
      const extMatch = String(filename).match(/\.([a-zA-Z0-9]+)$/);
      const ext = extMatch ? extMatch[1] : 'pdf';
      filename = /\.[a-zA-Z0-9]+$/.test(downloadName)
        ? downloadName
        : `${downloadName}.${ext}`;
    }
    link.setAttribute('download', filename);
    
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link)
      ;
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response && error.response.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const payload = JSON.parse(reader.result);
            const errorMsg = payload?.error || payload?.message || 'File not found';
            resolve({
              data: null,
              error: errorMsg
            });
          } catch (e) {
            resolve({
              data: null,
              error: 'File not found'
            });
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return {
      data: null,
      error: error.message
    };
  }
};

export const generated_forms_fetch_file = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/generated_forms_download/${id}`, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const disposition = response.headers['content-disposition'];
    let filename = 'form';
    if (disposition && disposition.includes('filename=')) {
      filename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
    }

    return {
      data: response.data,
      filename,
      status: response.status,
    };
  } catch (error) {
    if (error.response && error.response.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const payload = JSON.parse(reader.result);
            resolve({
              data: null,
              error: payload?.error || payload?.message || 'File not found',
            });
          } catch (e) {
            resolve({ data: null, error: 'File not found' });
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return { data: null, error: error.message };
  }
};

export const generated_forms_view_iframe_url = (id) => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token") || "";
  const base = String(api.defaults.baseURL || "").replace(/\/$/, "");
  const params = new URLSearchParams();
  if (token) params.set("jwt", token);
  const query = params.toString();
  return `${base}/generated_forms_view/${id}${query ? `?${query}` : ""}`;
};

export const generated_forms_view_file = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/generated_forms_view/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 120000,
    });
    const contentType = response.headers?.['content-type'] || '';
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      try {
        const payload = JSON.parse(text);
        return { blob: null, error: payload?.error || 'View failed' };
      } catch {
        return { blob: null, error: 'View failed' };
      }
    }
    return { blob: response.data, status: response.status };
  } catch (error) {
    if (error.response?.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const payload = JSON.parse(reader.result);
            resolve({ blob: null, error: payload.error || payload.message });
          } catch {
            resolve({ blob: null, error: 'Something went wrong' });
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return { blob: null, error: error.message };
  }
};

export const generated_forms_download_zip = async (ids, filename = 'generated_forms.zip') => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post(
      '/generated_forms_download_zip',
      { ids, filename },
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const blob = response.data;
    const contentType = response.headers?.['content-type'] || blob?.type || '';
    if (contentType.includes('application/json')) {
      const text = await blob.text();
      try {
        const payload = JSON.parse(text);
        return { data: null, error: payload?.error || payload?.message || 'Download failed' };
      } catch {
        return { data: null, error: 'Download failed' };
      }
    }

    const disposition = response.headers?.['content-disposition'] || '';
    let downloadName = filename || 'generated_forms.zip';
    const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
    if (utfMatch) {
      try {
        downloadName = decodeURIComponent(utfMatch[1].trim());
      } catch {
        downloadName = utfMatch[1].trim();
      }
    } else if (plainMatch) {
      downloadName = plainMatch[1].replace(/['"]/g, '').trim() || downloadName;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { data: blob, status: response.status };
  } catch (error) {
    if (error.response && error.response.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const payload = JSON.parse(reader.result);
            resolve({
              data: null,
              error: payload?.error || payload?.message || 'Download failed',
            });
          } catch (e) {
            resolve({ data: null, error: 'Download failed' });
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return { data: null, error: error.message };
  }
};

// selected_retuns_form_generation
export const DownloadGenerateForm = async (formInput) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/selected_form_generation', formInput, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${formInput.client_name}_${formInput.unit_id}_${formInput.form_type}_${formInput.date}.xlsx`);
    document.body.appendChild(link)
      ;
    link.click();

    link.parentNode.removeChild(link)
      ;
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response && error.response.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const errorMsg = JSON.parse(reader.result).error;
            console.log(errorMsg);
            resolve({
              data: null,
              error: errorMsg
            });
          } catch (e) {
            const errorMsg = 'Something went wrong';
            resolve({
              data: null,
              error: errorMsg
            });
          }
        };
        reader.readAsText(error.response.data);
      });
    } else {
      return {
        data: null,
        error: error.message
      };
    }
  }
};

/** LIST — for /generated-form/list table */
export const fetchGeneratedFormsFiltered = async ({ clientId, unitId, kind, overview } = {}) => {
  try {
    const user = sessionStorage.getItem('user');
    const company_code = user ? JSON.parse(user).company_code : null;
    const token = sessionStorage.getItem('token');

    const params = {};
    if (clientId) params.selectedClientID = clientId;
    if (unitId) params.unit_id = unitId;
    if (kind) params.kind = kind;
    if (overview) params.overview = 1;

    const response = await api.get(`/get_generated_form/${company_code}`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const releaseGeneratedForm = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post(`/release_generated_form/${id}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const releaseGeneratedFormsBulk = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/release_generated_forms', { ids }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

/** VIEW stored form — format: pdf (preview) | excel (download) */
export const fetchStoredGeneratedFormBlob = async ({
  client_id,
  unit_id,
  date,
  filename = null,
  form_type = null,
  format = 'pdf',
}) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = { client_id, unit_id, date, format };
    if (filename) params.filename = filename;
    if (form_type) params.form_type = form_type;

    const response = await api.get('/view_stored_generated_form', {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
      params,
      timeout: format === 'pdf' ? 120000 : 60000,
    });

    return { blob: response.data, status: response.status, format };
  } catch (error) {
    if (error.response?.data) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const payload = JSON.parse(reader.result);
            resolve({ blob: null, error: payload.error });
          } catch {
            resolve({ blob: null, error: 'Something went wrong' });
          }
        };
        reader.readAsText(error.response.data);
      });
    }
    return { blob: null, error: error.message };
  }
};
